import * as React from 'react';
import { Button } from 'antd';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as moment from 'moment';
import * as uuid from 'uuid';
import validator from 'validator';

import { Column } from 'src/core/ui/data-table.view';
import { TextView } from 'src/core/ui/text.view';
import { DateView } from 'src/core/ui/date.view';
import { CurrencyEditorView } from 'src/app/general/currencies/parts/currency-editor.view';
import { ToastNotifications } from 'src/core/ui/toast';

interface GroupedRates {
	displayName: string;
	fromCurrency: number;
	toCurrency: number;
	fromCurrencyRate?: number;
	toCurrencyRate?: number;
	bookingDateFromText: string;
	bookingDateToText: string;
	serviceDateFromText: string;
	serviceDateToText: string;
	isNew: boolean;
}

const currencyExchangeRateCreator = function (item: GroupedRates, self: CurrencyExchangeRateListView, startEditing?: boolean) {

	this.uuid = uuid.v4();
	this.displayName = item.displayName;
	this.fromCurrency = item.fromCurrency;
	this.toCurrency = item.toCurrency;
	this.fromCurrencyRate = item.fromCurrencyRate;
	this.toCurrencyRate = item.toCurrencyRate;
	this.bookingDateFromText = item.bookingDateFromText;
	this.bookingDateToText = item.bookingDateToText;
	this.serviceDateFromText = item.serviceDateFromText;
	this.serviceDateToText = item.serviceDateToText;
	this.isNew = item.isNew;

	this.currency = item;
	this.isEditing = false;

	this.edit = function () {
		const currentEdit = self.currencies ? self.currencies.find(e => e.isEditing == true) : null;

		if (currentEdit) {
			const errors = self.isValid(currentEdit.fromCurrencyRate, currentEdit.toCurrencyRate);
			if (errors.length == 0) {
				currentEdit.isEditing = false;
			}
			else {
				self.toast.showToast('Validation error!', errors, 'error');
			}
		}
		if (this != currentEdit) {
			this.isEditing = true;
		}
		self.forceUpdate();
	};
	this.delete = function () {
		let todelted = self.deleteDates([this.currency]);
		self.props.model.delete(todelted);
		self.currencies.splice(self.currencies.findIndex(e => e.uuid == this.uuid), 1);
	};

	if (startEditing) {
		this.edit();
	}

}

interface CurrencyExchangeRateListViewProps extends ComponentViewProps<DataSet<CurrencyExchangeRateItem>> {
	defaultCurrency: CurrencySummary;
	currencies: CurrencySummary[];
	title: string,
	listToGroup: CurrencyExchangeRateItem[];
	onItemDoubleClicked?: (item: CurrencyExchangeRateItem) => any;
	createNewDates: () => Promise<void | CurrencyExchangeRateItem[]>;
	groupByCurrencies: (items: CurrencyExchangeRateItem[]) => GroupedRates[];
	currenciesGrouped: any[];
}

@observer
export class CurrencyExchangeRateListView extends React.Component<CurrencyExchangeRateListViewProps, any> {
	@observable
	currencies: any[] = [];
	@resolve
	public toast: ToastNotifications;

	constructor(props: any) {
		super(props);
	}
	public isValid(fromCurrencyRate: any, toCurrencyRate: any): string[] {
		let message = [];
		if (!validator.isDecimal(toCurrencyRate.toString()) && !validator.isNumeric(toCurrencyRate.toString())) {
			message.push('rate to must be a numer');
		}
		if (!validator.isDecimal(fromCurrencyRate.toString()) && !validator.isNumeric(fromCurrencyRate.toString())) {
			message.push('rate from must be a numer');
		}
		return message;
	}
	isValidRangeDate(dateFrom: Date, dateTo: Date): boolean {
		let isValid = dateFrom <= dateTo;
		return isValid;
	}

	componentWillReceiveProps(nextProps: Readonly<CurrencyExchangeRateListViewProps>, nextContext: any) {
		this.currencies = [];
		let group = this.groupByCurrencies(nextProps.model.items || []);
		for (let g of group)
			this.currencies.push(new currencyExchangeRateCreator(g, this, false));
	}

	@autobind
	createCurrencyExchangeRate() {
		this.props.createNewDates().then(currencies => {
			if (Array.isArray(currencies)) {
				let group = this.groupByCurrencies(currencies);
				for (let g of group)
					this.currencies.push(new currencyExchangeRateCreator(g, this, true));

			}
		});
	}

	render() {
		if (this.props.defaultCurrency == undefined) return null;
		const model = this.currencies;
		let constr: any[] = [];
		//let group = this.groupByCurrencies(this.props.model.items);
		if (model != null && model.length > 0)
			model.map((d) => {
				constr.push(<tr key={d.uuid} onDoubleClick={d.isEditing ? null : d.edit.bind(d)}>
					<td className='cell'>
						<Button.Group>
							<Button icon={d.isEditing ? 'close' : 'edit'} onClick={d.edit.bind(d)} />
							<Button icon={'delete'} onClick={d.delete.bind(d)} />
						</Button.Group>
					</td>
					<td className={d.isEditing ? 'cell' : ''}>
						{
							d.isEditing && d.isNew ? <CurrencyEditorView label={null} mode='edit'
								onChange={newVal => {
									if (newVal) {
										this.setCurrencyProps(d.currency, newVal.id);
										d.displayName = newVal.iso3Name;
										d.currency.displayName = newVal.iso3Name;
									}

								}}
								value={d.displayName} currencies={this.props.currencies} currencyArrayObjectType={true} />
								: d.displayName
						}
					</td>
					<td className={d.isEditing ? 'cell' : ''}>
						{
							!d.isEditing ? d.bookingDateFromText : <DateView
								mode='edit'
								label={null}
								value={d.bookingDateFromText}
								onChanged={(newVal: any) => {
									if (newVal) {
										let date = new Date(newVal);
										newVal = moment.utc(date).format('LL');
										if (this.isValidRangeDate(date, new Date(d.bookingDateToText))) {
											d.bookingDateFromText = newVal;
											d.currency.bookingDateFromText = newVal;
											this.setCurrencyDatesProp(d.currency, 'bookingDateFromText', newVal);
										} else {
											newVal = moment.utc(new Date(d.bookingDateFromText)).format('LL');
											d.bookingDateFromText = newVal;
											d.currency.bookingDateFromText = newVal;
											this.setCurrencyDatesProp(d.currency, 'bookingDateFromText', newVal);
										}

									}
								}}
								format='small-date'
								dateUsage="utc"
							/>
						}
					</td>
					<td className={d.isEditing ? 'cell' : ''}>
						{
							!d.isEditing ? d.bookingDateToText : <DateView
								mode='edit'
								label={null}
								value={d.bookingDateToText}
								onChanged={(newVal: any) => {
									if (newVal) {
										let date = new Date(newVal);
										newVal = moment.utc(date).format('LL');
										if (this.isValidRangeDate(new Date(d.bookingDateFromText), date)) {
											d.bookingDateToText = newVal;
											d.currency.bookingDateToText = newVal;
											this.setCurrencyDatesProp(d.currency, 'bookingDateToText', newVal);

										} else {
											newVal = moment.utc(new Date(d.bookingDateToText)).format('LL');
											d.bookingDateToText = newVal;
											d.currency.bookingDateToText = newVal;
											this.setCurrencyDatesProp(d.currency, 'bookingDateFromText', newVal);
										}

									}

								}}
								format='small-date'
								dateUsage="utc"
							/>
						}
					</td>
					<td className={d.isEditing ? 'cell' : ''}>
						{
							!d.isEditing ? d.serviceDateFromText : <DateView
								mode='edit'
								label={null}
								value={d.serviceDateFromText}
								onChanged={(newVal: any) => {
									if (newVal) {
										let date = new Date(newVal);
										newVal = moment.utc(date).format('LL');
										if (this.isValidRangeDate(date, new Date(d.serviceDateToText))) {
											d.serviceDateFromText = newVal;
											d.currency.serviceDateFromText = newVal;
											this.setCurrencyDatesProp(d.currency, 'serviceDateFromText', newVal);

										} else {
											newVal = moment.utc(new Date(d.serviceDateFromText)).format('LL');
											d.serviceDateFromText = newVal;
											d.currency.serviceDateFromText = newVal;
											this.setCurrencyDatesProp(d.currency, 'serviceDateFromText', newVal);
										}
									}
								}}
								format='small-date'
								dateUsage="utc"
							/>
						}
					</td>
					<td className={d.isEditing ? 'cell' : ''}>
						{
							!d.isEditing ? d.serviceDateToText : <DateView mode='edit' label={null} value={d.serviceDateToText} onChanged={(newVal: any) => {
								if (newVal) {
									let date = new Date(newVal);
									newVal = moment.utc(date).format('LL');
									if (this.isValidRangeDate(new Date(d.serviceDateFromText), date)) {

										d.serviceDateToText = newVal;
										d.currency.serviceDateToText = newVal;
										this.setCurrencyDatesProp(d.currency, 'serviceDateToText', newVal);

									}
									else {
										newVal = moment.utc(new Date(d.serviceDateToText)).format('LL');
										d.serviceDateToText = newVal;
										d.currency.serviceDateToText = newVal;
										this.setCurrencyDatesProp(d.currency, 'serviceDateToText', newVal);
									}

								}

							}} format='small-date' />
						}
					</td>
					<td className={d.isEditing ? 'cell' : ''}>
						{
							!d.isEditing ? d.fromCurrencyRate : <TextView mode='edit' label={null}
								value={d.fromCurrencyRate}
								onChanged={newVal => {
									d.fromCurrencyRate = newVal;
									this.setCurrencyRateProp(d.currency, 'fromCurrencyRate', newVal);
								}} />
						}
					</td>
					<td className={d.isEditing ? 'cell' : ''}>
						{
							!d.isEditing ? d.toCurrencyRate : <TextView mode='edit' label={null}
								value={d.toCurrencyRate}
								onChanged={newVal => {
									d.toCurrencyRate = newVal;
									this.setCurrencyRateProp(d.currency, 'toCurrencyRate', newVal)
								}} />
						}
					</td>
				</tr>);
			});
		return <div className="card card-borderless">
			<h2>
				{this.props.title}
			</h2>
			<Button icon="plus" key="AddNewPhoneGrid" onClick={() => { this.createCurrencyExchangeRate() }} >New</Button>
			<table className="b-table" key="dailyTable">
				<thead>
					<tr>
						<th style={{ width: 90 }} ></th>
						<th style={{ width: 70 }}>Currency</th>
						<th style={{ width: 130 }}>Booking From</th>
						<th style={{ width: 130 }}>Booking To</th>
						<th style={{ width: 130 }}>Service From</th>
						<th style={{ width: 130 }}>Service To</th>
						<th style={{ width: 90 }}>{`From ${this.props.defaultCurrency.iso3Name}`}</th>
						<th style={{ width: 90 }}>{`To ${this.props.defaultCurrency.iso3Name}`}</th>
					</tr>
				</thead>
				<tbody key='body-exchange-list'>
					{
						constr
					}
				</tbody>
			</table>
		</div>;
	}

	@autobind
	private groupByCurrencies(items: CurrencyExchangeRateItem[]): GroupedRates[] {
		const rows: GroupedRates[] = [];
		if (items)
			for (const rate of items) {
				if (rate.fromCurrencyId != this.props.defaultCurrency.id && rate.toCurrencyId != this.props.defaultCurrency.id) continue;
				const fromCurrency = this.props.currencies.find(c => c.id == rate.fromCurrencyId);
				const toCurrency = this.props.currencies.find(c => c.id == rate.toCurrencyId);
				const isFrom = fromCurrency.id == this.props.defaultCurrency.id;
				let obj: GroupedRates = rows.find(e => e.displayName == (isFrom ? toCurrency : fromCurrency).iso3Name
					&& rate.bookingDateFromText == e.bookingDateFromText && rate.bookingDateToText == e.bookingDateToText
					&& rate.serviceDateFromText == e.serviceDateFromText && rate.serviceDateToText == e.serviceDateToText);
				if (obj == null) {
					obj = {
						isNew: rate.entity.entityState == 20,
						displayName: (isFrom ? toCurrency : fromCurrency).iso3Name,
						fromCurrency: isFrom ? rate.id : null,
						toCurrency: isFrom ? null : rate.id,
						bookingDateFromText: rate.bookingDateFromText,
						bookingDateToText: rate.bookingDateToText,
						serviceDateFromText: rate.serviceDateFromText,
						serviceDateToText: rate.serviceDateToText
					};
					rows.push(obj);
				}
				if (isFrom) {
					obj.fromCurrency = rate.id;
				} else {
					obj.toCurrency = rate.id;
				}
				obj[isFrom ? 'fromCurrencyRate' : 'toCurrencyRate'] = rate.rate;
			}
		return rows;
	}

	@autobind
	private renderCell(item?: any, index?: number, column?: Column, isSelected?: boolean, canEdit?: boolean): any {
		let fieldContent = item[column.dataIndex];

		switch (column.key) {
			case 'displayName':
				return isSelected && item.isNew && canEdit
					? <CurrencyEditorView label={null} mode='edit'
						onChange={newVal => {
							if (newVal)
								this.setCurrencyProps(item, newVal.id)
						}}
						value={item.displayName} currencies={this.props.currencies} currencyArrayObjectType={true} />
					: <span className='table-inline-text'>{fieldContent}</span>;
			case 'bookingDateFromText':
			case 'bookingDateToText':
			case 'serviceDateFromText':
			case 'serviceDateToText':
				return isSelected && canEdit
					? <DateView
						mode='edit'
						label={null}
						value={fieldContent}
						onChanged={newVal => this.setCurrencyDatesProp(item, column.dataIndex, newVal)}
						format='small-date'
						dateUsage="utc"
					/>
					: <span>{fieldContent}</span>;
			case 'fromCurrencyRate':
			case 'toCurrencyRate':
				return isSelected && canEdit
					? <TextView mode='edit' label={null} value={fieldContent} onChanged={newVal => this.setCurrencyRateProp(item, column.dataIndex, newVal)} />
					: <span>{fieldContent}</span>;
			default:
				return <span>{fieldContent}</span>;
		}
	}

	@autobind
	private setCurrencyRateProp(item: GroupedRates, field: string, value: any) {
		if (field == 'fromCurrencyRate') {
			const i = this.props.model.items.find(e => e.id == item.fromCurrency);
			i.rate = value;
		} else {
			const i = this.props.model.items.find(e => e.id == item.toCurrency);
			i.rate = value;
		}
	}

	@autobind
	private setCurrencyDatesProp(item: GroupedRates, field: string, value: any) {
		const items = this.props.model.items.filter(e => e.id == item.fromCurrency || e.id == item.toCurrency);
		for (const i of items) {
			i[field.replace('Text', '')] = value;
		}
	}

	@autobind
	private setCurrencyProps(item: GroupedRates, value: any) {

		const items = this.props.model.items.filter(e => e.id == item.fromCurrency || e.id == item.toCurrency);
		for (const i of items) {
			const fromCurrency = this.props.currencies.find(c => c.id == i.fromCurrencyId);
			const toCurrency = this.props.currencies.find(c => c.id == i.toCurrencyId);
			const isFrom = fromCurrency.id == this.props.defaultCurrency.id;
			if (isFrom) {
				i.toCurrencyId = value;
			} else {
				i.fromCurrencyId = value;
			}
		}
	}

	@autobind
	public deleteDates(items: any[]) {
		let groups: CurrencyExchangeRateItem[] = [];
		for (const item of items) {
			groups = groups.concat(this.props.model.items.filter(e => e.id == item.fromCurrency || e.id == item.toCurrency));
		}
		return groups;
	}
}



// WEBPACK FOOTER //
// ./src/app/products/currency-exchange-rates/list/currency-exchange-rate-list.view.tsx